import { combineReducers } from 'redux-immutable';

import parameters from './parameters';
import quote from './quote';
import cart from './cart';
import parametersChanged from './parameters_changed'

export default combineReducers({
  parameters,
  quote,
  cart,
  parametersChanged,
});
